import CourseList from './CourseList'
export default CourseList
